import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ProjectDetailPage } from "@/pages/project/ProjectDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/project/$projectId/")({
  component: ProtectedProjectDetailPage,
});

function ProtectedProjectDetailPage() {
  return (
    <ProtectedRoute>
      <ProjectDetailPage />
    </ProtectedRoute>
  );
}
